import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import newsletterService from './NewsletterService';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { FormGroup, Form, Label, Input, Button } from 'reactstrap';
import { withTranslation } from 'react-i18next';
//import { CKEditor } from '@ckeditor/ckeditor5-react';
import ReactQuill, { Quill } from 'react-quill';
import imageResize from 'quill-image-resize-module-react';
import 'react-quill/dist/quill.snow.css';

//import 'tinymce/tinymce';
//import 'tinymce/icons/default';
//import 'tinymce/themes/silver';
////import 'tinymce/plugins/paste';
//import 'tinymce/plugins/link';
//import 'tinymce/plugins/image';
//import 'tinymce/plugins/table';
//import 'tinymce/skins/ui/oxide/skin.min.css';
//import 'tinymce/skins/ui/oxide/content.min.css';
//import 'tinymce/skins/content/default/content.min.css';
//import { Editor } from '@tinymce/tinymce-react'


Quill.register('modules/imageResize', imageResize);

function NewsletterEditorPlain(props) {
	const { match, history, t } = props;
	const id = match.params.id;
	const [entity, setEntity] = useState({ id: null, name: '', content: '', sendDate: '', enabled: false });
	const [loading, setLoading] = useState(true);

	// Quill toolbar and formats
	const quillModules = {
		toolbar: [
			['bold', 'italic', 'underline'],        // toggled buttons
			['blockquote'],
			['link', 'image', 'video'],

			[{ 'header': 1 }, { 'header': 2 }],               // custom button values
			[{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
			[{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
			[{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent

			[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
			[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

			[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
			[{ 'font': [] }],
			[{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],

			['clean']                
		],
		clipboard: {
			// toggle to add extra line breaks when pasting HTML:
			matchVisual: false
		},
		imageResize: {
			parchment: Quill.import('parchment'),
			modules: ["Resize", "DisplaySize"]
		},
	};

	const quillFormats = [
		'header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'image','align','width','height','size','font','color','background'
	];

	useEffect(() => {
		retrieveFormData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleInputChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		setEntity((prev) => ({ ...prev, [name]: value }));
	}

	const handleClickCancel = () => {
		history.push('/newsletters');
	}

	const handleValidSubmit = async (event, values) => {
		let postvalues = { ...values };
		// ensure content included
		postvalues.content = entity.content;
		// include enabled from local state (checkbox)
		postvalues.enabled = entity.enabled;
		if (id) {
			postvalues.id = id;
			await newsletterService.update(id, postvalues);
			history.push('/newsletters');
		} else {
			await newsletterService.add(postvalues);
			history.push('/newsletters');
		}
	}

	const renderForm = (entity) => {
		return (
			<AvForm model={entity} onValidSubmit={handleValidSubmit}>
				<AvField name="id" type="hidden" />
				<AvField name="name" label={t('Title')} required errorMessage={t('FieldInvalid')} validate={{
					required: { value: true, errorMessage: t('FieldRequired') },
					minLength: { value: 2 }
				}} />

				{/* Rich text editor for content */}
				<FormGroup>
					<Label for="content">{t('Content')}</Label>
					<ReactQuill
						value={entity.content || ''}
						onChange={(value) => setEntity(prev => ({ ...prev, content: value }))}
						modules={quillModules}
						formats={quillFormats}
					/>
					{/*<Editor*/}
					{/*	initialValue="<p>This is the initial content of the editor</p>"*/}
					{/*	init={{*/}
					{/*		skin: false,*/}
					{/*		content_css: false,*/}
					{/*		height: 500,*/}
					{/*		menubar: false,*/}
					{/*		plugins: [*/}
					{/*			'link image',*/}
					{/*			'table'*/}
					{/*		],*/}
					{/*		toolbar:*/}
					{/*			'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help'*/}
					{/*	}}*/}
					{/*	value={entity.content}*/}
					{/*	onEditorChange={(value) => setEntity(prev => ({ ...prev, content: value }))}*/}
					{/*/>*/}
				</FormGroup>

				<AvField name="sendDate" label={t('SendDate')} type="date" required />

				<FormGroup>
					<Label for="enabled">{t('Enabled')}</Label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<Input type="checkbox" name="enabled" id="enabled" checked={entity.enabled || false} onChange={handleInputChange} />
				</FormGroup>

				<FormGroup>
					<Button type="submit">{t('Save')}</Button>&nbsp;
					<Button type="button" onClick={handleClickCancel}>{t('Cancel')}</Button>
				</FormGroup>
			</AvForm>
		);
	}

	return (
		<div>
			<h1 id="tabelLabel">Newsletter</h1>
			{loading ? <p><em>Loading...</em></p> : renderForm(entity)}
		</div>
	);

	async function retrieveFormData() {
		if (id) {
			const data = await newsletterService.get(id);
			// controller returns NewsletterModel with properties: id, name, content, sendDate, enabled
			if (data.sendDate != null && data.sendDate.length > 0) {
				data.sendDate = data.sendDate.split('T')[0];
			}
			// ensure enabled property present
			data.enabled = data.enabled || false;
			setEntity(data);
			setLoading(false);
		} else {
			// new
			const today = new Date().toISOString().split('T')[0];
			setEntity({ id: null, name: '', content: '', sendDate: today, enabled: false });
			setLoading(false);
		}
	}
}

export const NewsletterEditor = withTranslation()(withRouter(NewsletterEditorPlain));
